export default "__VITE_ASSET__CSEhI5p___"